var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificaciones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_69_7",
    "data-name": "Componente 69 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications_FILL0_wght300_GRAD0_opsz40",
    d: "M180.917-836.1a.884.884,0,0,1-.653-.265.894.894,0,0,1-.264-.656.878.878,0,0,1,.264-.652.893.893,0,0,1,.653-.26h1.721v-11.31a8.289,8.289,0,0,1,1.8-5.258,7.709,7.709,0,0,1,4.676-2.883v-.8a1.759,1.759,0,0,1,.531-1.292,1.756,1.756,0,0,1,1.291-.532,1.762,1.762,0,0,1,1.292.532,1.757,1.757,0,0,1,.533,1.292v.8a7.688,7.688,0,0,1,4.676,2.878,8.289,8.289,0,0,1,1.8,5.258v11.31h1.721a.884.884,0,0,1,.653.265.894.894,0,0,1,.264.656.878.878,0,0,1-.264.652.893.893,0,0,1-.653.26ZM190.943-846.824Zm0,14.825a2.535,2.535,0,0,1-1.862-.775,2.542,2.542,0,0,1-.773-1.863h5.275a2.537,2.537,0,0,1-.775,1.864A2.546,2.546,0,0,1,190.94-832Zm-6.469-5.929h12.943v-11.31a6.238,6.238,0,0,0-1.892-4.579,6.238,6.238,0,0,0-4.579-1.892,6.238,6.238,0,0,0-4.579,1.892,6.238,6.238,0,0,0-1.892,4.579Z",
    transform: "translate(-175.002 861.998)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.2a40d0a7077368fc4e25200a641ba412.svg";
export { ForwardRef as ReactComponent };